import { Editor, Path, Range, Transforms } from 'slate';

export default function removeInlineIfSelected(editor, evt, type) {
  const { selection } = editor;
  const { inputType } = evt;

  if (inputType === 'insertText') {
    const inlineNodes = [
      ...Editor.nodes(editor, {
        match: n => {
          return n.type === type;
        },
      }),
    ];
    const inlineEntry = inlineNodes.length ? inlineNodes[0] : null;

    if (inlineEntry) {
      const leaf = Editor.leaf(editor, selection.anchor);
      const start = Range.start(selection);
      const end = Range.end(selection);

      const isInlineSelected =
        Path.equals(start.path, end.path) && start.offset === 0 && end.offset === leaf[0].text.length;

      if (isInlineSelected) {
        evt.preventDefault();
        Transforms.removeNodes(editor, { at: inlineEntry[1] });
        Transforms.insertText(editor, evt.data);
        return true;
      }
    }
  }
  return false;
}
